$(function () {
	initForm();
});

function initForm() {
	$("#cmdLogIn").click(function () {
		checkCredentials();
	});

	var credCheck = function (e) {
		if (e.which === 13 || e.keycode === 13) {
			checkCredentials();
		}
	}

	$("#formLogin #UserName").on("keypress", credCheck);
	$("#formLogin #Password").on("keypress", credCheck);
}

function checkCredentials() {
	const INCLUDE_IDENTITY_LOGOUT = "INCLUDE_IDENTITY_LOGOUT";
	const INVALID_LOGIN = "Account does not exist or password is incorrect.";
	const INVALID_IPADDRESS = "Ip Address not allowed for anonymous login.";
	const ERROR_TEXT = "An error occurred";

	// The server answers a successful log-in with this prefix followed by where to go next. It is
	// needed because this is an AJAX post: the browser never follows the server's redirect, so
	// without being told the destination we could only ever return to the viewer's landing page.
	// That is what stopped a visitor sent here from a document link getting their document.
	const REDIRECT = "REDIRECT:";

	var userName = $("#formLogin #UserName").val();
	var password = $("#formLogin #Password").val();
	var fragment = $("#formLogin #Fragment").val();
	var returnUrl = $("#formLogin #ReturnUrl").val();

	$.ajax({
		url: $("#formLogin").attr("action"),
		data: {
			UserName: userName,
			Password: password,
			Fragment: fragment,
			ReturnUrl: returnUrl
		},
		method: "POST"
	}).done(function (objResult) {
		// Checked first: the destination is server-validated, and an ordinary HTML response can
		// never start with this marker.
		if (objResult.indexOf(REDIRECT) === 0) {
			document.location = objResult.substring(REDIRECT.length);
		} else if (objResult.indexOf(ERROR_TEXT) > 0) {
			redirectToError();
		} else {
			if (objResult.indexOf(INVALID_LOGIN) > 0) {
				$("#loginModal").html(objResult);
				initForm();
			} else if (objResult.indexOf(INVALID_IPADDRESS) > 0) {
				redirectToWV404();
			} else if (objResult.indexOf(INCLUDE_IDENTITY_LOGOUT) !== -1) {
				document.location = $("#webViewerURL").val() + "?includeIdentityLogout=true";
			} else {
				document.location = $("#webViewerURL").val();
			}
		}
	}).fail(function () { //xhr, ajaxOptions, thrownError
		redirectToError();
	});
}

function redirectToAction(routeAction) {

	var url = "Home/" + routeAction;
	var path = window.location.href;

	//Sometimes the path looks like this and causes issues:  http://localhost:19582/home/index?ReturnUrl=%2f
	//173847: Split on the ? in case there already is a redirect we will just ignore that and go to the default Menu.
	if (path.indexOf("?") > 0) {
		path = path.split("?")[0];
	}

	//Must rebuild the path so that it works in all cases:
	if (path.indexOf("home/")) {
		path = path.substr(0, path.indexOf("home/"));
	}
	var redirectUrl = path + url;
	document.location = redirectUrl;
}

function redirectToError() {
	var redirectUrl = "error/index";
	document.location = redirectUrl;
}

function redirectToWV404() {
	var redirectUrl = "NotFound404";
	document.location = redirectUrl;
}
